import React, { useRef, useState } from "react";
import { useEffect } from "react";
// import { useSelector } from "react-redux";
import { useParams, useNavigate } from "react-router-dom";

import Loading from "../../Others/Loading";
import { jsPDF } from "jspdf";
import toast from "react-hot-toast";
// import logo3 from "../../img/logo3.jpeg";
import { round, toTitleCase } from "../../Others/functions";
import { cancelOrder, fetchOrderDetails } from "../../Request/OrderRequests";
import { Collapse } from "react-bootstrap";
import { useSelector } from "react-redux";

function strfDate(date) {
  let dates = new Date(date).toDateString().slice(0, 10);
  let year = new Date(date).toDateString().slice(10, 15);
  let time = new Date(date).toLocaleTimeString();
  return dates + ", " + year + ", " + time;
}

function invoiceDate() {
  let date = new Date();
  let thisdate = date.toDateString().slice(4, 10);
  let thisyear = date.toDateString().slice(10, 15);
  // let year = date.toDateString.slice(10,15);
  return thisdate + ", " + thisyear;
}

// const OutputType = {
//   Save: "save", //save pdf as a file
//   DataUriString: "datauristring", //returns the data uri string
//   DataUri: "datauri", //opens the data uri in current window
//   DataUrlNewWindow: "dataurlnewwindow", //opens the data uri in new window
//   Blob: "blob", //return blob format of the doc,
//   ArrayBuffer: "arraybuffer", //return ArrayBuffer format
// };
// eslint-disable-next-line
//cancelled
function jsPDFInvoiceTemplate(props) {
  const param = {
    outputType: "save",
    returnJsPDFDocObject: true,
    fileName: "Invoice 2021",
    orientationLandscape: false,
    // logo: {
    //   src: logo3,
    //   width: 53.33, //aspect ratio = width/height
    //   height: 26.66,
    //   margin: {
    //     top: 0, //negative or positive num, from the current position
    //     left: 0, //negative or positive num, from the current position
    //   },
    // },
    business: {
      name: props?.order?.order?.[0]?.vendorBusiness,
      address: toTitleCase(props?.order?.order?.[0]?.vendor_city),
      phone: "(+355) 069 11 11 111",
      email: props?.order?.order?.[0]?.email,
      website: "www.example.al",
    },
    contact: {
      label: "Invoice issued for:",
      name: props?.order?.order?.[0]?.name,
      address:
        props?.order?.order?.[0]?.address_line_1 +
        ", " +
        props?.order?.order?.[0]?.address_line_2 +
        props?.order?.order?.[0]?.city,
      state:
        props?.order?.order?.[0]?.state +
        ", " +
        props?.order?.order?.[0]?.pincode,
      phone: props?.order?.order?.[0]?.phoneNo,
      email: "client@website.al",
    },
    invoice: {
      label: "Invoice #: ",
      num: 19,
      invDate:
        props?.order?.order?.[0]?.status +
        " on: " +
        strfDate(props?.order?.order?.[0]?.statusDate),
      invGenDate: "Invoice Date: " + invoiceDate(),
      headerBorder: false,
      tableBodyBorder: false,
      header: [
        "#",
        "Product Name",
        // "Description",
        "Price",
        "Quantity",
        "Offer Available",
        "Total",
      ],
      // table: Array.from(Array(5), (item, index) => [
      //   index + 1,
      //   "There are many variations ",
      //   "Lorem Ipsum is simply dummy text ",
      //   200.5,
      //   4.5,
      //   42.5,
      //   400.5,
      // ]),
      // invTotalLabel: "Total:",
      // invTotal: "145,250.50",
      // invCurrency: "ALL",
      // row1: {
      //   col1: "VAT:",
      //   col2: "20",
      //   col3: "%",
      //   style: {
      //     fontSize: 10, //optional, default 12
      //   },
      // },
      table: Array.from(props?.order?.suborder, (item, index) => [
        index + 1,
        toTitleCase(props?.order?.suborder?.[index]?.product_name),
        // "Lorem Ipsum is simply dummy text ",
        props?.order?.suborder?.[index]?.sp,
        props?.order?.suborder?.[index]?.qty,
        "Yes",
        props?.order?.suborder?.[index]?.sp *
          props?.order?.suborder?.[index]?.qty,
      ]),
      invTotalLabel: "Total:",
      // Math.round(props?.order?.order?.[0]?.order_total * 0.18).toString()
      invTotal:
        props?.order?.order?.[0]?.order_total +
        Math.round(props?.order?.order?.[0]?.order_total * 0.18) +
        " ",
      invCurrency: "ALL",
      row1: {
        col1: "GST:",
        col2: "18",
        col3: "%",
        style: {
          fontSize: 10, //optional, default 12
        },
      },
      row2: {
        col1: "SubTotal:",
        col2: props?.order?.order?.[0]?.order_total + " ",
        col3: "ALL",
        style: {
          fontSize: 10, //optional, default 12
        },
      },
      invDescLabel: "Invoice Note",
      invDesc: "",
      // "There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which don't look even slightly believable. If you are going to use a passage of Lorem Ipsum, you need to be sure there isn't anything embarrassing hidden in the middle of text. All the Lorem Ipsum generators on the Internet tend to repeat predefined chunks as necessary.",
    },
    footer: {
      text: "The invoice is created on a computer and is valid without the signature and stamp.",
    },
    pageEnable: true,
    pageLabel: "Page ",
  };

  const splitTextAndGetHeight = (text, size) => {
    var lines = doc.splitTextToSize(text, size);
    return {
      text: lines,
      height: doc.getTextDimensions(lines).h,
    };
  };
  if (param.invoice.table && param.invoice.table.length) {
    if (param.invoice.table[0].length !== param.invoice.header.length)
      throw Error("Length of header and table column must be equal.");
  }

  const options = {
    orientation: param.orientationLandscape ? "landscape" : "",
  };

  var doc = new jsPDF(options);

  var docWidth = doc.internal.pageSize.width;
  var docHeight = doc.internal.pageSize.height;

  var colorBlack = "#000000";
  var colorGray = "#4d4e53";
  //starting at 15mm
  var currentHeight = 15;
  //var startPointRectPanel1 = currentHeight + 6;

  var pdfConfig = {
    headerTextSize: 20,
    labelTextSize: 12,
    fieldTextSize: 10,
    lineHeight: 6,
    subLineHeight: 4,
  };

  doc.setFontSize(pdfConfig.headerTextSize);
  doc.setTextColor(colorBlack);
  doc.text(docWidth - 10, currentHeight, param.business.name, "right");
  doc.setFontSize(pdfConfig.fieldTextSize);

  // if (param.logo.src) {
  //   var imageHeader = new Image();
  //   imageHeader.src = param.logo.src;
  //   //doc.text(htmlDoc.sessionDateText, docWidth - (doc.getTextWidth(htmlDoc.sessionDateText) + 10), currentHeight);
  //   doc.addImage(
  //     imageHeader,
  //     10 + param.logo.margin.left,
  //     currentHeight - 5 + param.logo.margin.top,
  //     param.logo.width,
  //     param.logo.height
  //   );
  // }

  doc.setTextColor(colorGray);

  currentHeight += pdfConfig.subLineHeight;
  currentHeight += pdfConfig.subLineHeight;
  doc.text(docWidth - 10, currentHeight, param.business.address, "right");
  currentHeight += pdfConfig.subLineHeight;
  doc.text(docWidth - 10, currentHeight, param.business.phone, "right");
  doc.setFontSize(pdfConfig.fieldTextSize);
  // doc.setTextColor(colorGray);
  currentHeight += pdfConfig.subLineHeight;
  doc.text(docWidth - 10, currentHeight, param.business.email, "right");

  // currentHeight += pdfConfig.subLineHeight;
  // doc.text(docWidth - 10, currentHeight, param.business.email_1, "right");

  currentHeight += pdfConfig.subLineHeight;
  doc.text(docWidth - 10, currentHeight, param.business.website, "right");

  currentHeight += pdfConfig.subLineHeight;

  //line breaker after logo & business info
  if (param.invoice.header.length) {
    currentHeight += pdfConfig.subLineHeight;
    doc.line(10, currentHeight, docWidth - 10, currentHeight);
  }

  //Contact part
  doc.setTextColor(colorGray);
  doc.setFontSize(pdfConfig.fieldTextSize);
  currentHeight += pdfConfig.lineHeight;
  if (param.contact.label) {
    doc.text(10, currentHeight, param.contact.label);
    currentHeight += pdfConfig.lineHeight;
  }

  doc.setTextColor(colorBlack);
  doc.setFontSize(pdfConfig.headerTextSize - 5);
  if (param.contact.name) doc.text(10, currentHeight, param.contact.name);

  if (param.invoice.label && param.invoice.num) {
    doc.text(
      docWidth - 10,
      currentHeight,
      param.invoice.label + param.invoice.num,
      "right"
    );
  }

  if (param.contact.name || (param.invoice.label && param.invoice.num))
    currentHeight += pdfConfig.subLineHeight;

  doc.setTextColor(colorGray);
  doc.setFontSize(pdfConfig.fieldTextSize - 2);

  if (param.contact.address || param.invoice.invDate) {
    doc.text(10, currentHeight, param.contact.address);
    doc.text(docWidth - 10, currentHeight, param.invoice.invDate, "right");
    currentHeight += pdfConfig.subLineHeight;
  }

  if (param.contact.phone || param.invoice.invGenDate) {
    doc.text(10, currentHeight, param.contact.phone);
    doc.text(docWidth - 10, currentHeight, param.invoice.invGenDate, "right");
    currentHeight += pdfConfig.subLineHeight;
  }

  if (param.contact.email) {
    doc.text(10, currentHeight, param.contact.email);
    currentHeight += pdfConfig.subLineHeight;
  }

  if (param.contact.otherInfo)
    doc.text(10, currentHeight, param.contact.otherInfo);
  else currentHeight -= pdfConfig.subLineHeight;
  //end contact part

  //TABLE PART
  //var tdWidth = 31.66;
  //10 margin left - 10 margin right
  var tdWidth = (doc.getPageWidth() - 20) / param.invoice.header.length;

  var addTableHeaderBoarder = () => {
    currentHeight += 2;
    for (let i = 0; i < param.invoice.header.length; i++) {
      if (i === 0) doc.rect(10, currentHeight, tdWidth, 7);
      else doc.rect(tdWidth * i + 10, currentHeight, tdWidth, 7);
    }
    currentHeight -= 2;
  };
  var addTableBodyBoarder = (lineHeight) => {
    for (let i = 0; i < param.invoice.header.length; i++) {
      if (i === 0) doc.rect(10, currentHeight, tdWidth, lineHeight);
      else doc.rect(tdWidth * i + 10, currentHeight, tdWidth, lineHeight);
    }
  };
  var addTableHeader = () => {
    if (param.invoice.headerBorder) addTableHeaderBoarder();

    currentHeight += pdfConfig.subLineHeight;
    doc.setTextColor(colorBlack);
    doc.setFontSize(pdfConfig.fieldTextSize);
    //border color
    doc.setDrawColor(colorGray);
    currentHeight += 2;

    param.invoice.header.forEach(function (row, index) {
      if (index === 0) doc.text(row, 11, currentHeight);
      else doc.text(row, index * tdWidth + 11, currentHeight);
    });

    currentHeight += pdfConfig.subLineHeight - 1;
    doc.setTextColor(colorGray);
  };
  addTableHeader();

  //table body
  var tableBodyLength = param.invoice.table.length;
  param.invoice.table.forEach(function (row, index) {
    doc.line(10, currentHeight, docWidth - 10, currentHeight);

    //get nax height for the current row
    let rowsHeight = [];
    var getRowsHeight = function () {
      row.forEach(function (rr, index) {
        //size should be the same used in other td
        let item = splitTextAndGetHeight(rr.toString(), tdWidth - 1); //minus 1, to fix the padding issue between borders
        rowsHeight.push(item.height);
      });
    };
    getRowsHeight();
    var maxHeight = Math.max(...rowsHeight);

    //body borders
    if (param.invoice.tableBodyBorder) addTableBodyBoarder(maxHeight + 1);

    //display text into row cells
    //Object.entries(row).forEach(function(col, index) {
    row.forEach(function (rr, index) {
      let item = splitTextAndGetHeight(rr.toString(), tdWidth - 1); //minus 1, to fix the padding issue between borders

      if (index === 0) doc.text(item.text, 11, currentHeight + 4);
      else doc.text(item.text, 11 + index * tdWidth, currentHeight + 4);
    });

    currentHeight += maxHeight - 4;

    //td border height
    currentHeight += 5;

    //pre-increase currentHeight to check the height based on next row
    if (index + 1 < tableBodyLength) currentHeight += maxHeight;

    if (
      param.orientationLandscape &&
      (currentHeight > 185 ||
        (currentHeight > 178 && doc.getNumberOfPages() > 1))
    ) {
      doc.addPage();
      currentHeight = 10;
      if (index + 1 < tableBodyLength) addTableHeader();
    }

    if (
      !param.orientationLandscape &&
      (currentHeight > 265 ||
        (currentHeight > 255 && doc.getNumberOfPages() > 1))
    ) {
      doc.addPage();
      currentHeight = 10;
      if (index + 1 < tableBodyLength) addTableHeader();
      //       else
      //         currentHeight += pdfConfig.subLineHeight + 2 + pdfConfig.subLineHeight - 1; //same as in addtableHeader
    }

    //reset the height that was increased to check the next row
    if (index + 1 < tableBodyLength && currentHeight > 30)
      // check if new page
      currentHeight -= maxHeight;
  });
  //     doc.line(10, currentHeight, docWidth - 10, currentHeight); //nese duam te shfaqim line ne fund te tabeles

  var invDescSize = splitTextAndGetHeight(
    param.invoice.invDesc,
    docWidth / 2
  ).height;
  //END TABLE PART

  if (param.orientationLandscape && currentHeight + invDescSize > 173) {
    doc.addPage();
    currentHeight = 10;
  }

  if (!param.orientationLandscape && currentHeight + invDescSize > 270) {
    doc.addPage();
    currentHeight = 10;
  }

  doc.setTextColor(colorBlack);
  doc.setFontSize(pdfConfig.labelTextSize);
  currentHeight += pdfConfig.lineHeight;

  //line breaker before invoce total
  if (
    param.invoice.header.length &&
    (param.invoice.invTotal ||
      param.invoice.invTotalLabel ||
      param.invoice.invCurrency)
  ) {
    doc.line(docWidth / 2, currentHeight, docWidth - 10, currentHeight);
    currentHeight += pdfConfig.lineHeight;
  }

  //     doc.text("Faleminderit!", 10, currentHeight);
  doc.text(docWidth / 1.5, currentHeight, param.invoice.invTotalLabel, "right");
  doc.text(docWidth - 25, currentHeight, param.invoice.invTotal, "right");
  doc.text(docWidth - 10, currentHeight, param.invoice.invCurrency, "right");

  //row1
  if (
    param.invoice.row1 &&
    (param.invoice.row1.col1 ||
      param.invoice.row1.col2 ||
      param.invoice.row1.col3)
  ) {
    currentHeight += pdfConfig.lineHeight;
    doc.setFontSize(param.invoice.row1.style.fontSize);

    doc.text(docWidth / 1.5, currentHeight, param.invoice.row1.col1, "right");
    doc.text(docWidth - 25, currentHeight, param.invoice.row1.col2, "right");
    doc.text(docWidth - 10, currentHeight, param.invoice.row1.col3, "right");
  }
  //end row1

  //row2
  if (
    param.invoice.row2 &&
    (param.invoice.row2.col1 ||
      param.invoice.row2.col2 ||
      param.invoice.row2.col3)
  ) {
    currentHeight += pdfConfig.lineHeight;
    doc.setFontSize(param.invoice.row2.style.fontSize);

    doc.text(docWidth / 1.5, currentHeight, param.invoice.row2.col1, "right");
    doc.text(docWidth - 25, currentHeight, param.invoice.row2.col2, "right");
    doc.text(docWidth - 10, currentHeight, param.invoice.row2.col3, "right");
  }
  //end row2

  if (param.orientationLandscape && currentHeight + invDescSize > 173) {
    doc.addPage();
    currentHeight = 10;
  }

  if (!param.orientationLandscape && currentHeight + invDescSize > 270) {
    doc.addPage();
    currentHeight = 10;
  }

  doc.setTextColor(colorBlack);
  currentHeight += pdfConfig.subLineHeight;
  currentHeight += pdfConfig.subLineHeight;
  //   currentHeight += pdfConfig.subLineHeight;
  doc.setFontSize(pdfConfig.labelTextSize);

  //add num of pages at the bottom
  if (doc.getNumberOfPages() > 1) {
    for (let i = 1; i <= doc.getNumberOfPages(); i++) {
      doc.setFontSize(pdfConfig.fieldTextSize - 2);
      doc.setTextColor(colorGray);

      if (param.pageEnable) {
        doc.text(docWidth / 2, docHeight - 10, param.footer.text, "center");
        doc.setPage(i);
        doc.text(
          param.pageLabel + " " + i + " / " + doc.getNumberOfPages(),
          docWidth - 20,
          doc.internal.pageSize.height - 6
        );
      }

      if (param.orientationLandscape && currentHeight + invDescSize > 183) {
        doc.addPage();
        currentHeight = 10;
      }

      if (!param.orientationLandscape && currentHeight + invDescSize > 270) {
        doc.addPage();
        currentHeight = 10;
      }
    }
  }

  var addInvoiceDesc = () => {
    doc.setFontSize(pdfConfig.labelTextSize);
    doc.setTextColor(colorBlack);

    doc.text(param.invoice.invDescLabel, 10, currentHeight);
    currentHeight += pdfConfig.subLineHeight;
    doc.setTextColor(colorGray);
    doc.setFontSize(pdfConfig.fieldTextSize - 1);

    var lines = doc.splitTextToSize(param.invoice.invDesc, docWidth / 2);
    //text in left half
    doc.text(lines, 10, currentHeight);
    currentHeight +=
      doc.getTextDimensions(lines).h > 5
        ? doc.getTextDimensions(lines).h + 6
        : pdfConfig.lineHeight;

    return currentHeight;
  };
  addInvoiceDesc();

  //add num of page at the bottom
  if (doc.getNumberOfPages() === 1 && param.pageEnable) {
    doc.setFontSize(pdfConfig.fieldTextSize - 2);
    doc.setTextColor(colorGray);
    doc.text(docWidth / 2, docHeight - 10, param.footer.text, "center");
    doc.text(
      param.pageLabel + "1 / 1",
      docWidth - 20,
      doc.internal.pageSize.height - 6
    );
  }

  let returnObj = {
    pagesNumber: doc.getNumberOfPages(),
  };

  if (param.returnJsPDFDocObject) {
    returnObj = {
      ...returnObj,
      jsPDFDocObject: doc,
    };
  }

  if (param.outputType === "save") doc.save(param.fileName);
  else if (param.outputType === "blob") {
    const blobOutput = doc.output("blob");
    returnObj = {
      ...returnObj,
      blob: blobOutput,
    };
  } else if (param.outputType === "datauristring") {
    returnObj = {
      ...returnObj,
      dataUriString: doc.output("datauristring", {
        filename: param.fileName,
      }),
    };
  } else if (param.outputType === "arraybuffer") {
    returnObj = {
      ...returnObj,
      arrayBuffer: doc.output("arraybuffer"),
    };
  } else
    doc.output(param.outputType, {
      filename: param.fileName,
    });

  return returnObj;
}

function OrderPage() {
  // const vendor = useSelector((state) => state.vendorReducer.vendor);
  const [order, setOrder] = useState(null);
  const order_id = useParams().id;
  const [load, setLoad] = useState(false);
  const navigate = useNavigate();
  const textRef = useRef();
  const closeRef = useRef();
  const cancelReasons = [
    "Placed order by mistake.",
    "Got better price elsewhere.",
    "Delivery time is too long.",
    "Change delivery address/phone number.",
    "Others",
  ];
  const [reason, setReason] = useState(null);
  const [otherReason, setOther] = useState("");
  const name = useSelector((u) => u.user.info?.name);

  useEffect(() => {
    if (order_id) {
      fetchOrderDetails(order_id)
        .then((res) => setOrder(res))
        .catch((err) => console.log(err));
    }
  }, [order_id]);
  // console.log(order);
  return (
    <>
      <div className="bg-white">
        <>
          {order ? (
            <>
              <div className="sticky-top" style={{ backgroundColor: "white" }}>
                <div className="py-1 d-flex bg-orange text-light">
                  <div className="w-75 mt-auto ps-3">
                    <div className="d-flex">
                      <span
                        className="bi bi-arrow-left fs-3 my-auto"
                        onClick={() => navigate(-1)}
                      ></span>
                      <div className="d-flex flex-column ms-3 lh-sm">
                        <div className="d-flex fs-5">
                          Order{" "}
                          <span className="ms-1 fs-5">
                            #{order?.order?.[0]?.vendor_order_no}
                          </span>
                        </div>
                        <div className="d-flex" style={{ fontSize: "12px" }}>
                          {`${order?.order?.[0]?.status} | ${order?.order?.[0]?.order_count} items | ₹${order?.order?.[0]?.order_grand_total}`}
                          {/* <div>{order?.order?.[0]?.status}</div>
                          <div className="mx-2"> | </div>
                          <div className="" style={{ whiteSpace: "nowrap" }}>
                            {order?.order?.[0]?.order_count} items
                          </div>
                          <div className="mx-2"> | </div>
                          <div>₹{order?.order?.[0]?.order_grand_total}</div> */}
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              <div className="d-flex align-items-center sep mx-3 round border-0 pt-4">
                <hr className="w-100" />
                <div className="px-3 d-flex" style={{whiteSpace:"nowrap"}}>
                  <span className="text-uppercase text-orange fs-5 fw-bold">Status</span>
                </div>
                <hr className="w-100" />
              </div>
              <div>
                <div className="mb-2 mx-2">
                  <div className="d-flex flex-column ms-1 pt-1">
                    <div className="d-flex">
                      <i
                        className="bi bi-geo-alt-fill text-grey"
                        style={{ fontSize: "30px", lineHeight:"34px" }}
                      ></i>
                      <div className="ms-2 d-flex flex-column">
                        <div className="fw-bold text-muted fs-5 lh-sm">
                          {order?.order?.[0]?.["vendorBusiness"]}
                        </div>
                        <div className="lh-1">
                          <span className="fs-6 text-muted">
                            {order?.order?.[0]?.["vendor_city"]}
                          </span>
                        </div>
                      </div>
                    </div>
                    <div
                      className="left-border"
                      style={{ height: "36px", marginLeft: "13px" }}
                    >
                      <span className="visually-hidden">Hi</span>
                    </div>
                    <div className="d-flex" style={{ marginTop: "4px" }}>
                      <i
                        className="bi bi-geo-alt-fill text-orange "
                        style={{ fontSize: "30px", lineHeight:"34px" }}
                      ></i>
                      <div className="ms-2 d-flex flex-column">
                        <div className="fw-bold fs-5 text-muted">Other</div>
                        <div className="lh-1">
                          <span className="fs-6 text-muted">
                            {order?.order?.[0]?.["address_line_1"] +
                              ", " +
                              order?.order?.[0]?.["address_line_2"] +
                              ", " +
                              order?.order?.[0]?.["city"]}
                              
                          </span>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* Below Border */}
                  <div className="mt-3 px-2">
                    {order?.order?.[0]?.status === "Pending" ? (
                      <div>
                        <div className="d-flex w-100 px-1 border bg-light round">
                          <div
                            className="rounded-circle"
                            style={{
                              marginLeft: "7px",
                              marginRight: "10px",
                              marginTop: "7px",
                              marginBottom: "5px",
                            }}
                          >
                            <i className="bi bi-clock-history text-brown my-auto fs-1"></i>
                          </div>
                          <div className="d-flex flex-column my-auto py-1 pe-2">
                            <div className="lh-1 pe-2">
                              <span className="text-brown fw-bold fs-5 d-block">
                                Ordered on
                              </span>
                              <span className="text-muted fs-6">
                                {" "}
                                {strfDate(order?.order?.[0]?.["orderDate"])}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : order?.order?.[0]?.status === "Accepted" ? (
                      <div>
                        <div className="d-flex w-100 px-1 border bg-light round">
                          <div
                            className="rounded-circle"
                            style={{
                              marginLeft: "7px",
                              marginRight: "10px",
                              marginTop: "7px",
                              marginBottom: "5px",
                            }}
                          >
                            <i className="bi bi-handbag-fill text-green my-auto fs-1"></i>
                          </div>
                          <div className="d-flex flex-column my-auto py-1 pe-2">
                            <div className="lh-1 pe-2">
                              <span className="text-green fw-bold fs-5 d-block">
                                Accepted on
                              </span>
                              <span className="text-muted fs-6">
                                {" "}
                                {strfDate(order?.order?.[0]?.["statusDate"])}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : order?.order?.[0]?.status === "Delivered" ? (
                      <div>
                        <div className="d-flex w-100 px-1 border bg-light round">
                          <div
                            className="rounded-circle"
                            style={{
                              marginLeft: "7px",
                              marginRight: "10px",
                              marginTop: "7px",
                              marginBottom: "5px",
                            }}
                          >
                            <i className="bi bi-check-lg text-orange my-auto fs-1"></i>
                          </div>
                          <div className="d-flex flex-column my-auto py-1 pe-2">
                            <div className="lh-1 pe-2">
                              <span className="text-orange fw-bold fs-5 d-block">
                                Delivered on
                              </span>
                              <span className="text-muted fs-6">
                                {" "}
                                {strfDate(order?.order?.[0]?.["statusDate"])}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : order?.order?.[0]?.status === "Cancelled" ? (
                      <div>
                        {" "}
                        <div className="d-flex">
                          <div
                            className="rounded-circle bg-white me-2 px-1"
                            style={{
                              marginLeft: "5px",
                              marginTop: "5px",
                              marginBottom: "5px",
                            }}
                          >
                            <i className="bi bi-x-lg icon-red my-auto fw-bolder fs-4"></i>
                          </div>
                          <div className="d-flex flex-column my-auto py-1 pe-2">
                            <div className="lh-1 pe-2">
                              <span
                                className="text-muted fw-bold"
                                // style={{ fontSize: "18px" }}
                              >
                                Cancelled on{" "}
                                {strfDate(order?.order?.[0]?.["statusDate"])}
                              </span>
                            </div>
                          </div>
                        </div>
                      </div>
                    ) : (
                      ""
                    )}
                  </div>
                </div>
              </div>
              <div className="d-flex align-items-center sep mx-3 round border-0 pt-3">
                <hr className="w-100" />
                <div className="px-3 d-flex" style={{whiteSpace:"nowrap"}}>
                  <span className="text-uppercase text-orange fs-5 fw-bold">Details</span>
                </div>
                <hr className="w-100" />
              </div>
              <div className="px-3">
                {order?.suborder?.map((key, i) => {
                  return (
                    <div className="d-flex flex-row" key={i}>
                      {/* <img
                        src={key.product_img}
                        className="my-auto round"
                        width="75px"
                        height="75px"
                        alt=""
                      /> */}
                      <div className="pb-2 pt-1 d-flex align-items-center flex-fill">
                        <i className="bi bi-stop-circle text-muted" style={{marginBottom:"1px"}}></i>
                        <span className="fs-6 text-muted ms-2 lh-1">
                          {toTitleCase(key.product_name)}{" "}
                          <span style={{ whiteSpace: "nowrap" }}>
                            x {key.qty}
                          </span>
                        </span>
                        <div className="ms-auto ps-2 text-muted fw-bold my-auto">
                          ₹
                          <span>
                            {round(key.qty * key.sp, 2)?.toLocaleString(
                              "en-IN"
                            )}
                          </span>
                        </div>
                      </div>
                    </div>
                  );
                })}
              </div>
              <div className="border-bottom border-2 mx-3"></div>
              <div className="py-1">
                <div className="">
                  <div className="d-flex px-3">
                    <div className="mt-2 text-muted fw-bold">MRP</div>
                    <div className="ms-auto mt-2 text-muted fw-bold">
                      ₹{order?.order?.[0]?.order_mrp.toLocaleString("en-IN")}
                    </div>
                  </div>
                  {Boolean(order?.order?.[0]?.product_discount) && (
                    <div className="d-flex mt-0 px-3">
                      <div className="mt-1 text-muted fw-bold">
                        Product discount
                      </div>
                      <div className="ms-auto text-muted fw-bold">
                        -₹
                        {order?.order?.[0]?.product_discount?.toLocaleString(
                          "en-IN"
                        ) || 0}
                      </div>
                    </div>
                  )}
                  {Boolean(order?.order?.[0]?.slab_discount) && (
                    <div className="d-flex mt-0 px-3">
                      <div className="mt-1 text-muted fw-bold">
                        Slab discount
                      </div>
                      <div className="ms-auto text-green fw-bold">
                        -₹
                        {order?.order?.[0]?.slab_discount?.toLocaleString(
                          "en-IN"
                        ) || 0}
                      </div>
                    </div>
                  )}
                  {Boolean(order?.order?.[0]?.cart_discount_pcnt) && (
                    <div className="d-flex mt-0 px-3">
                      <div className="mt-1 text-muted fw-bold">
                        {order?.order?.[0]?.cart_discount_pcnt
                          ? `${order?.order?.[0]?.cart_discount_pcnt}% `
                          : ""}
                        Cart discount
                      </div>
                      <div className="ms-auto fw-bold text-green ">
                        -₹
                        {order?.order?.[0]?.cart_discount_amt?.toLocaleString(
                          "en-IN"
                        ) || 0}
                      </div>
                    </div>
                  )}
                  <div className="d-flex align-items-center mt-2 bg-light border-top px-3 py-2">
                    <div className="w-100 d-flex align-items-center">
                      <span className="fs-4 fw-bold me-2">Grand Total</span>
                      <div className="bg-light-orange text-orange round-3 fw-bolder px-2 fs-6 rounded">
                        COD
                      </div>
                    </div>
                    <div className="fs-4 fw-bold text-green text-end">
                      ₹
                      {order?.order?.[0]?.order_grand_total.toLocaleString(
                        "en-IN"
                      )}
                    </div>
                  </div>

                  {/* Cancel button */}
                  {order?.order?.[0]?.status === "Pending" && (
                    <div>
                      {/* <div className="gap"></div> */}
                      <br />
                      <br />
                      <div className="d-flex fixed-bottom w-100">
                        <button
                          className="btn btn-danger border border-danger w-100 fs-5 py-2 m-2"
                          data-bs-toggle="offcanvas"
                          data-bs-target="#cancelPopup"
                        >
                          Cancel Order
                        </button>
                      </div>
                    </div>
                  )}

                  {/* Cancel Reason Modal */}
                  <div
                    className="offcanvas bg-tr offcanvas-bottom h-auto round-top overflow-hidden"
                    tabIndex="-1"
                    id="cancelPopup"
                  >
                    <div className="modal-content bg-tr">
                      <div
                        className="w-100 d-flex"
                        data-bs-dismiss="offcanvas"
                        ref={closeRef}
                      >
                        <div className="bi bi-x-circle fs-lg text-light mx-auto"></div>
                      </div>
                      <div className="bg-danger py-1 fs-3 round-top text-center text-light">
                        Cancel Order
                      </div>
                      <div className="offcanvas-body small bg-white pb-2">
                        {cancelReasons.map((reason, i) => (
                          <div className="form-check d-flex ms-3 py-1" key={i}>
                            <input
                              className="form-check-input my-auto"
                              type="radio"
                              name="reason"
                              id={i}
                              onClick={() => setReason(i)}
                            />
                            <label
                              className="form-check-label ms-3"
                              htmlFor={i}
                            >
                              {reason}
                            </label>
                          </div>
                        ))}
                        <Collapse
                          in={cancelReasons?.[reason] === "Others"}
                          onEntered={() => textRef.current.focus()}
                        >
                          <div className="w-100 px-4">
                            <textarea
                              ref={textRef}
                              className="form-control border round"
                              rows="3"
                              placeholder="Enter your reason..."
                              value={otherReason}
                              onChange={(e) => setOther(e.target.value)}
                            ></textarea>
                          </div>
                        </Collapse>
                        <br />
                        <div className="d-flex w-100">
                          <button
                            disabled={
                              reason === null ||
                              (cancelReasons[reason] === "Others" &&
                                !otherReason.length) ||
                              load
                            }
                            className="w-50 round py-1 fs-5 mx-auto btn btn-danger"
                            onClick={() => {
                              setLoad(true);
                              cancelOrder({
                                orderId: order_id,
                                cancelReason: cancelReasons[reason],
                                otherReason: otherReason,
                                name,
                              })
                                .then(() => {
                                  toast.success("Order cancelled");
                                  fetchOrderDetails(order_id)
                                    .then((res) => setOrder(res))
                                    .catch((err) => console.log(err))
                                    .finally(() => {
                                      setLoad(false);
                                      closeRef.current.click();
                                    });
                                })
                                .catch((err) => {
                                  console.log(err);
                                  setLoad(false);
                                });
                            }}
                          >
                            Cancel Order
                          </button>
                        </div>
                      </div>
                    </div>
                  </div>

                  {/* Download PDF */}
                  {/* Not For Production */}
                  {/* {order?.order?.[0]?.status === "Delivered" && (
                    <div>
                      <div className="gap"></div>
                      <div
                        className="d-flex border border-2 fixed-bottom"
                        style={{
                          backgroundColor: "#ECEFF1",
                          height: "50px",
                        }}
                      >
                        <div
                          className="my-auto mx-auto text-danger"
                          onClick={() => {
                            // download();
                            jsPDFInvoiceTemplate({ order });
                            toast.success("Downloading invoice");
                          }}
                        >
                          <span className="fs-5 fw-bolder">
                            Download Invoice
                          </span>
                        </div>
                      </div>
                    </div>
                  )} */}
                </div>
              </div>
            </>
          ) : (
            <Loading text="Getting order info" />
          )}
        </>
      </div>
    </>
  );
}

export default OrderPage;
